export default "__VITE_ASSET__Dr7ms4YY__"